import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Laura', 'Carlos', 'Ana', 'María', 'José', 'Pedro', 'Sofía', 'Miguel', 'Lucía', 'David', 'Elena', 'Javier', 'Carmen', 'Daniel', 'Paula', 'Alejandro', 'Isabel', 'Manuel'];
const CITIES = ['Ciudad de México', 'Buenos Aires', 'Madrid', 'Bogotá', 'Santiago', 'Lima', 'Caracas', 'Quito', 'Montevideo', 'Barcelona', 'Guadalajara', 'Medellín', 'Córdoba', 'Rosario', 'Valencia', 'Sevilla', 'Cali', 'Monterrey'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Recurring interval (random between 8-15 seconds + 4s display time)
    const interval = setInterval(() => {
      if (!isVisible) {
        const randomDelay = Math.floor(Math.random() * 7000) + 8000; // 8-15 seconds
        setTimeout(showPopup, randomDelay);
      }
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-15">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-xs w-full" data-id="element-16">
          <div className="bg-white border-l-4 border-green-500 shadow-xl rounded-lg p-4 flex items-start gap-3" data-id="element-17">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-18">
              <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-19" />
            </div>
            <div data-id="element-20">
              <p className="text-sm font-medium text-gray-900" data-id="element-21">
                <span className="font-bold" data-id="element-22">{data.name}</span> de {data.city}
              </p>
              <p className="text-xs text-gray-600 mt-1" data-id="element-23">
                acaba de comprar el{' '}
                <span className="font-semibold text-amber-800" data-id="element-24">
                  MegaPack Historia Lista
                </span>
              </p>
              <p className="text-[10px] text-gray-400 mt-1" data-id="element-25">
                Hace unos segundos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}